<template>
  <div class="sign-in-reward">
    <div class="header-process">
      <el-col :span="6">
        <span>天数:</span>
        <el-input
          style="width: 180px; margin: 0 10px"
          type="number"
          v-model="searchForm.checkInDays"
          placeholder="请输入天数"
        />
      </el-col>
      <el-col :span="6">
        <span>状态:</span>
        <el-select v-model="searchForm.valid" placeholder="请选择">
          <el-option
            v-for="item in otherOptions.validList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <span>渠道:</span>
        <el-select v-model="searchForm.channel" placeholder="请选择" filterable clearable>
          <el-option
            v-for="item in otherOptions.channelList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-button type="primary" @click="getSignTableData">查询</el-button>
        <el-button type="success" @click="dialogShow(false)">新增</el-button>
        <el-button type="success" @click="cloneInfo.visible = true">克隆</el-button>
      </el-col>
    </div>
    <el-table :data="rewardTable" border style="width: 100%" height="920">
      <el-table-column prop="days" label="签到天数" width="120"></el-table-column>
      <el-table-column prop="name" label="签到奖励" width="480">
        <template slot-scope="scope">
          {{ scope.row.rewardDetail || "无" }}
          <el-button type="text" @click="handleDetailReward(scope.row)">详情</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="channel" label="渠道"></el-table-column>
      <el-table-column prop="activityType" label="是否有效">
        <template slot-scope="scope">
          {{ scope.row.valid === 1 ? "有效" : "无效" }}
        </template>
      </el-table-column>
      <el-table-column prop="ctime" label="操作时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.ctime * 1000) }}
        </template>
      </el-table-column>
      <el-table-column prop="operator" label="操作人"></el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="warning" @click="dialogShow(true, scope.row)">更新</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="dialogData.isEdit ? '编辑' : '新增'"
      :visible.sync="dialogData.visible"
      width="40%"
      :before-close="handleDialogClose"
    >
      <el-form ref="form" :model="dialogData.data" label-width="80px">
        <el-form-item label="签到周期:">
          <el-input
            style="width: 200px; margin: 0 10px"
            type="number"
            v-model="dialogData.data.checkInDay"
            placeholder="请输入天数"
          />
        </el-form-item>
        <el-form-item label="渠道:">
          <el-select
            v-model="dialogData.data.channelList"
            multiple
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in otherOptions.channelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否有效:">
          <el-radio-group v-model="dialogData.data.valid">
            <el-radio :label="1">有效</el-radio>
            <el-radio :label="0">无效</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="handleDialogClose">取消</el-button>
        <el-button type="primary" @click="submitUpdateReward">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="克隆"
      :visible.sync="cloneInfo.visible"
      width="40%"
      :before-close="handleDialogClose"
    >
      <el-form ref="form" :model="cloneInfo.data" label-width="80px">
        <el-form-item label="源渠道:">
          <el-select
            v-model="cloneInfo.data.sourceChannel"
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in otherOptions.channelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目标渠道:">
          <el-select
            v-model="cloneInfo.data.targetChannel"
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in otherOptions.channelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 是否强制 -->
        <el-form-item label="是否强制:">
          <el-radio-group v-model="cloneInfo.data.force">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="handleDialogClose">取消</el-button>
        <el-button type="primary" @click="submitClone">确认</el-button>
      </div>
    </el-dialog>

    <reward-base-dialog
      v-model="detailDialogData.detailVisible"
      :row-data="detailDialogData.detail"
      v-if="detailDialogData.detailVisible"
    ></reward-base-dialog>
  </div>
</template>
<script>
import {
  getSignInTable,
  updateSignInTable,
  cloneSignData,
  deleteSignInTable,
} from "@/api/rewardConfigRequest.js";
import rewardBaseDialog from "./reward-base-dialog.vue";
export default {
  components: {
    rewardBaseDialog,
  },
  data() {
    return {
      // 搜索表单
      searchForm: {
        channel: "all",
        checkInDays: "",
        valid: null,
      },
      options: [],
      value: "",
      // 搜索的list
      otherOptions: {
        dayList: [
          { label: "全部", value: 0 },
          { label: "1天", value: 1 },
          { label: "2天", value: 2 },
          { label: "3天", value: 3 },
          { label: "4天", value: 4 },
          { label: "5天", value: 5 },
          { label: "6天", value: 6 },
        ],
        channelList: [],
        validList: [
          { label: "全部", value: null },
          { label: "有效", value: 1 },
          { label: "无效", value: 0 },
        ],
      },
      // 奖励表
      rewardTable: [],
      dialogData: {
        isEdit: false,
        visible: false,
        data: {
          checkInDay: 1,
          channelList: [],
          valid: 1,
          force: 0,
        },
      },
      cloneInfo: {
        visible: false,
        data: {
          sourceChannel: "",
          targetChannel: "",
          force: 0,
        },
      },
      detailDialogData: {
        detail: {},
        detailVisible: false,
      },
    };
  },
  mounted() {
    this.getAppList();
    this.getSignTableData();
  },
  methods: {
    dateFormat(input, pattern = "") {
      // 在参数列表中 通过 pattern="" 来指定形参默认值，防止报错
      var dt = new Date(input);
      // 获取年月日
      var y = dt.getFullYear();
      var m = (dt.getMonth() + 1).toString().padStart(2, "0");
      var d = dt.getDate().toString().padStart(2, "0");
      // 如果 传递进来的字符串类型，转为小写之后，等于 yyyy-mm-dd，那么就返回 年-月-日
      // 否则，就返回  年-月-日 时：分：秒
      if (pattern.toLowerCase() === "yyyy-mm-dd") {
        return `${y}-${m}-${d}`;
      } else {
        // 获取时分秒
        var hh = dt.getHours().toString().padStart(2, "0");
        var mm = dt.getMinutes().toString().padStart(2, "0");
        var ss = dt.getSeconds().toString().padStart(2, "0");
        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
      }
    },
    async submitClone() {
      const res = await cloneSignData(this.cloneInfo.data);
      if (res.code !== 0 && res.code !== 200 && res.code !== 1010) return this.$message.error(res.msg);
      if (res.code === 1010) {
        // 弹窗提示改渠道已有数据，是否要覆盖
        this.$confirm("该渠道已有数据，是否要覆盖？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.cloneInfo.data.force = 1;
            this.submitClone();
          })
          .catch(() => {
            this.cloneInfo.data.force = 0;
          });
        return;
      }
      this.getSignTableData();
      this.cloneInfo.visible = false;
    },
    // 展示提示消息
    showMsg(res) {
      if (res.code === 0 || res.code === 200) {
        this.$message({ type: "success", message: res.msg });
      } else {
        this.$message({ type: "warning", message: res.msg });
      }
    },
    // 获取渠道列表
    async getAppList() {
      const { data: res } = await this.$axios(
        this.$store.getters.path.channelList +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token
      );
      if (res.code == 0 || res.code == 200) {
        this.otherOptions.channelList = res.data;
        this.otherOptions.channelList.unshift({ label: "ALL", value: "all" });
      }
    },
    // 获取签到表
    async getSignTableData() {
      const res = await getSignInTable(this.searchForm);
      this.showMsg(res);
      if (res.code === 0 || res.code === 200) {
        this.rewardTable = res.data;
      }
    },
    // 弹窗弹起
    dialogShow(isEdit, row) {
      this.dialogData.visible = true;
      if (isEdit) {
        this.dialogData.data.checkInDay = row.days;
        this.dialogData.data.valid = row.valid;
        this.dialogData.data.channelList = [row.channel];
        this.$set(this.dialogData.data, "id", row.id);
        this.dialogData.isEdit = true;
      } else {
        this.dialogData.isEdit = false;
        this.dialogData.data = {
          checkInDay: 1,
          channelList: [],
          valid: 1,
          force: 0,
        };
      }
    },
    handleDialogClose() {
      this.dialogData.visible = false;
      this.dialogData.data = {
        checkInDay: 1,
        channelList: [],
        valid: 1,
        force: 0,
      };
      this.cloneInfo.visible = false;
      this.cloneInfo.data = {
        sourceChannel: "",
        targetChannel: "",
        force: 0,
      };
    },
    // 提交新增/修改操作
    async submitUpdateReward() {
      const res = await updateSignInTable(this.dialogData.data);
      if (res.code !== 0 && res.code !== 200 && res.code !== 1010) return this.$message.error(res.msg);
      if (res.code === 1010) {
        // 弹窗提示改渠道已有数据，是否要覆盖
        this.$confirm("该渠道已有数据，是否要覆盖？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.dialogData.data.force = 1;
            this.submitUpdateReward();
          })
          .catch(() => {
            this.dialogData.data.force = 0;
          });
        return;
      }
      this.getSignTableData();
      this.dialogData.visible = false;
    },

    handleDetailReward(row) {
      this.detailDialogData.detailVisible = true;
      this.detailDialogData.detail = row;
    },
  },
};
</script>
<style scoped lang="scss">
.sign-in-reward {
  .header-process {
    display: flow-root;
  }

  .el-select {
    margin: 0 10px;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
